import { FnLocalStorageService } from '../services/fn-local-storage.service';
import { IFnAppSession } from './fn-app-session.model';
import { FnUtilService } from '../services/fn-util.service';
import { Injectable } from '@angular/core';
import { isEmptyString, isNull } from '../util/check';

@Injectable()
export class FnAppSessionService extends FnLocalStorageService {
    private currentSession: IFnAppSession;
    private SESSION_KEY = 'FN_SESSION';
    private THEME_KEY = 'FN_THEME';

    constructor(private fnUtil: FnUtilService) {
        super();
    }

    setSessionKey(sessionKey: string) {
        this.SESSION_KEY = sessionKey;
        this.THEME_KEY = sessionKey + "_FN_THEME";
    }

    


    set(fnSession: IFnAppSession) {
        this.currentSession = fnSession;
        this.setFnSession(fnSession);
    }

    getSsPK() {
        return this.currentSession.ssPK;
    }

    setSsPK(ssPk: number) {
        this.currentSession.ssPK = ssPk;
        this.setFnSession(this.currentSession);
    }

    getSccPK() {
        return this.currentSession.sccPK;
    }

    setSccPK(sccPK: number) {
        this.currentSession.sccPK = sccPK;
        this.setFnSession(this.currentSession);
    }

    getScaPK() {
        return this.currentSession.scaPK;
    }

    setScaPK(scaPK: number) {
        this.currentSession.scaPK = scaPK;
        this.setFnSession(this.currentSession);
    }

    getSaPK() {
        return this.currentSession.saPK;
    }

    setSaPK(saPK: number) {
        this.currentSession.saPK = saPK;
        this.setFnSession(this.currentSession);
    }

    getScPK() {
        return this.currentSession.scPK;
    }

    setScPK(scPK: number) {
        this.currentSession.scPK = scPK;
        this.setFnSession(this.currentSession);
    }

    getScuPK() {
        return this.currentSession.scuPK;
    }

    setScuPK(scuPK: number) {
        this.currentSession.scuPK = scuPK;
        this.setFnSession(this.currentSession);
    }

    getSauPK() {
        return this.currentSession.sauPK;
    }

    setSauPK(sauPK: number) {
        this.currentSession.sauPK = sauPK;
        this.setFnSession(this.currentSession);
    }

    getWIndex() {
        return this.currentSession.wIndex;
    }

    setWIndex(wIndex: number) {
        this.currentSession.wIndex = wIndex;
        this.setFnSession(this.currentSession);
    }

    getMid() {
        return this.currentSession.mid;
    }

    setMid(mid: string) {
        this.currentSession.mid = mid;
        this.setFnSession(this.currentSession);
    }

    getBaseUrl() {
        return this.currentSession.baseUrl;
    }

    setBaseUrl(baseUrl: string) {
        this.currentSession.baseUrl = baseUrl;
        this.setFnSession(this.currentSession);
    }

    getSmobuPK() {
        return this.currentSession.smobuPK;
    }

    setSmobuPK(smobuPK: string) {
        this.currentSession.smobuPK = smobuPK;
        this.setFnSession(this.currentSession);
    }

    getFrnchGrpPk() {
        return this.currentSession.frnchGrpPk;
    }

    setFrnchGrpPk(frnchGrpPk: number) {
        this.currentSession.frnchGrpPk = frnchGrpPk;
        this.setFnSession(this.currentSession);
    }

    getFrnchUserPK() {
        return this.currentSession.frnchUserPk;
    }

    setFrnchUserPK(frnchUserPk: number) {
        this.currentSession.frnchUserPk = frnchUserPk;
        this.setFnSession(this.currentSession);
    }

    get() {
        if (this.fnUtil.isEmptyObject(this.currentSession)) {
            return this.fnUtil.copy(this.getFnSession());
        } else {
            return this.fnUtil.copy(this.currentSession);
        }
    }

    setTheme(theme: 'DARK' | 'LIGHT', isReloadPage = false) {
        this.setItem(this.THEME_KEY, theme);
        if (isReloadPage) {
            window.location.reload();
        }
    }

    isDarkTheme() {
        return this.getItem(this.THEME_KEY) === 'DARK';
    }

    getTheme() {
        return this.getItem(this.THEME_KEY);
    }

    setDefaultDarkTheme() {
        const theme = this.getTheme();
        if (isNull(theme) || isEmptyString(theme)) {
            this.setTheme('DARK');
        }
    }

    getSiteAppPK() {
        return this.currentSession.siteAppPK;
    }

    setSiteAppPK(siteAppPK: number) {
        this.currentSession.siteAppPK = siteAppPK;
        this.setFnSession(this.currentSession);
    }

    private setFnSession(fnSession: IFnAppSession) {
        this.setItem(
            this.SESSION_KEY,
            encodeURIComponent(JSON.stringify(fnSession))
        );
    }

    private getFnSession(): any {
        const session: string = this.getItem(this.SESSION_KEY);
        if (this.fnUtil.isEmptyObject(session)) {
            return;
        } else {
            const sessionJson: IFnAppSession = JSON.parse(
                decodeURIComponent(session)
            );
            this.currentSession = sessionJson;
            return sessionJson;
        }
    }

    clearFnSession() {
        this.currentSession = null;
        localStorage.setItem(this.SESSION_KEY, undefined);
    }
}
